import { Row } from "@narmi/design_system";
import styles from "./InfoRow.module.css";

interface InfoRowProps {
  label: string;
  value?: string | null;
}

function InfoRow(props: InfoRowProps) {
  return (
    <Row className={styles.infoRow}>
      <div className={styles.infoCell}>{props.label}</div>
      <div className={`${styles.infoCell} sentry-mask`}>{props?.value ?? ""}</div>
    </Row>
  );
}

export { InfoRow };
